import {ServerError} from "@hooks/useResponseHandler";

export const errorsContainCode = (errors: ServerError[], code: string) => {
  return errors.find((error) => error.code.includes(code))?.message || null;
}
